import React, { useState }  from 'react'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Input from '@mui/material/Input';
import TextField from '@mui/material/TextField';
import { useDispatch } from "react-redux";
import { closeInterpretationFileDialog } from '../state/interpretationfile/actions';
import { Checkbox, FormControl, FormControlLabel, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';

const InterpretationFileModal = ({
    open,
    value,
    setInterpretationFormData,
    handleFormData,
    interpretationFile,
    setInterpretationFile,
    controllers
}) => {
    
    const [fileError, setFileError] = useState('');

    const dispatch = useDispatch();
    // Function to set values of the Form Fields
    const changeHandler = (e) => {
        setInterpretationFormData((prevState) =>
        ({...prevState, [e.target.name]: e.target.value }));
    };

    // Function to set the file value
    const changeFileHandler = (event) => {
        if(event.target.files.length > 0){
            if(event.target.files[0].type !== 'application/json'){
                event.target.value = null;
                setFileError('Please upload Json format file.');
                return;
            }
            setFileError('');
            setInterpretationFile(event.target.files[0]);
        }
        
    };

        // Function to handle the close of Form popup
    const handleClose = (event, reason) => {
        setInterpretationFile('');
        setInterpretationFormData({
            releaseNotes:'',
            controllerId: '',
            isLatest: false
        });
        setFileError('');
        dispatch(closeInterpretationFileDialog());
    };

    const handleCheckBox = (e) => {
        setInterpretationFormData((prevState) => ({...prevState, "isLatest": e.target.checked}));
    };

    return (
        <Dialog fullWidth maxWidth="sm" open={open}>
            <DialogTitle>Upload Interpretation File</DialogTitle>
            <DialogContent dividers> 
                <InputLabel id="file-select-label">Upload File</InputLabel>
                <Input 
                    type="file" 
                    name="uploadFile"
                    fullWidth
                    onChange={changeFileHandler} 
                    error={interpretationFile === "" }              
                >Upload File</Input>
                { interpretationFile === "" ? <FormHelperText sx={{color:'#d32f2f'}} id="component-error-text">Required Field!</FormHelperText> : <></> }
                { fileError ? <FormHelperText sx={{color:'#d32f2f'}} id="component-error-text">{fileError}</FormHelperText> : <></> }
                <FormControl fullWidth sx={{  marginTop: 1 }}>
                    <InputLabel id="demo-simple-select-standard-label">Controllers</InputLabel>
                    <Select
                        label="Controllers"
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        sx={{ "&:focus": {
                            backgroundColor: "#ffffff"
                            } 
                        }}
                        value={value.controllerId || ''}
                        onChange={changeHandler}
                        name="controllerId"
                        error={value.controllerId === ""}
                    >
                        <MenuItem value="">Select Controller</MenuItem>
                        {controllers?.map((row, i) => (
                            <MenuItem value={row.id}>{row.controller_name}</MenuItem>
                        ))}
                    </Select>
                    <FormHelperText sx={{color:"#d32f2f"}} >{value.controllerId === "" ? "Required Field!" : " "}</FormHelperText>
                </FormControl>
                <TextField 
                    label="Release Notes" 
                    id="releaseNotes" 
                    name="releaseNotes"
                    multiline
                    rows={4}
                    fullWidth
                    value={value.releaseNotes}
                    onChange={changeHandler}
                    error={value.releaseNotes === ""}
                    helperText={value.releaseNotes === "" ? "Required Field!" : " "}
                /> 
                <FormControlLabel
                    control={ <Checkbox checked={value.isLatest} onChange={handleCheckBox} />}
                    label="Mark as Latest"
                    labelPlacement="start"
                    name="isLatest"
                />
            </DialogContent>
            <DialogActions>
                <Button  variant="contained"
                    size="medium"
                    color="primary" 
                    onClick={handleFormData}
                >Submit</Button>
                <Button  variant="contained"
                    size="medium"
                    color="error" onClick={handleClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    )
}

export default InterpretationFileModal
